// extracted by mini-css-extract-plugin
export default {"error-image":"Error_error-image__pwY-V"};